import { AthenaLogoNew } from "../logos/athena-new";
import { EGHVLogoNew } from "../logos/eghv-new";
import { GrecoLogoNew } from "../logos/greco-new";
import { SagautaLogoNew } from "../logos/sagauta-new";
import { VGMLogoNew } from "../logos/vgm-new";

export const logoEG = [0];
export const logoGreco = [
  26, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22,
  23, 24, 25, 27, 28, 29,
];
export const logoVGM = [5];
export const logoSagauta: number[] = [];
export const logoAthena = [20];

export const companyData = [
  {
    id: 0,
    logoURL: undefined,
    country: "AT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    teamsText: "Contact Me Via Teams",
    telephone: "+43 5 04 04 ",
    mobile: "+43 664 ",
    fax: "+43 5 04 04  11 ",
    companyName: "Ecclesia GrECo Hospital Versicherungsmakler GmbH",
    companyDisplayName: "Ecclesia GrECo Hospital Versicherungsmakler GmbH",
    logo: EGHVLogoNew,
    activityDescription: "Risikoberater und Versicherungsmakler",
    streetNumber: "Elmargasse 2-4",
    countryZIP: "A-1190 Wien",
    website: "www.eghv.at",
    infoOne: "HG Wien, FN 264542 h",
    infoTwo: "Firmensitz: Wien",
    infoThree: "GISA-Zahl 24681513",
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-austria",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Datenschutzerklärung",
        protectionURL:
          "https://greco.services/wp-content/uploads/2024/11/ATEGHV_PRIVACY_NOTICE_CLIENTS.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Diese Information ist ausschließlich für den Adressaten bestimmt und kann vertrauliche und geschützte Informationen enthalten. Die Verwendung durch Andere, Veröffentlichung, Kopie und Verteilung dieser Information an Dritte ist nicht gestattet. Sollten Sie nicht der beabsichtigte Empfänger sein, verständigen Sie bitte den Absender und löschen Sie dieses E-Mail dann sofort.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 1,
    logoURL: undefined,
    country: "AT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+43 5 04 04 ",
    mobile: "+43 664 ",
    fax: "+43 5 04 04  11 ",
    companyName: "GrECo International AG",
    companyDisplayName: "GrECo International AG",
    logo: GrecoLogoNew,
    activityDescription: "Risikoberater und Versicherungsmakler",
    streetNumber: "Elmargasse 2-4",
    countryZIP: "A-1190 Wien",
    website: "www.greco.services",
    infoOne: "HG Wien, FN 249231 t",
    infoTwo: "Firmensitz: Wien",
    infoThree: "GISA-Zahl 24158374",
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-austria",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Datenschutzerklärung",
        protectionURL: "https://greco.services/ATGI_PRIVACY_NOTICE_CLIENTS/",
      },
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL:
          "https://greco.services/wp-content/uploads/2024/11/ATGI_PRIVACY_NOTICE_CLIENTS_EN.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Diese Information ist ausschließlich für den Adressaten bestimmt und kann vertrauliche und geschützte Informationen enthalten. Die Verwendung durch Andere, Veröffentlichung, Kopie und Verteilung dieser Information an Dritte ist nicht gestattet. Sollten Sie nicht der beabsichtigte Empfänger sein, verständigen Sie bitte den Absender und löschen Sie dieses E-Mail dann sofort.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 2,
    logoURL: undefined,
    country: "AT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+43 5 04 04 ",
    mobile: "+43 664 ",
    fax: "+43 5 04 04  11 ",
    companyName: "GrECo International Holding AG",
    companyDisplayName: "GrECo International Holding AG",
    logo: GrecoLogoNew,
    activityDescription: "Risk Consultants and Insurance Brokers",
    streetNumber: "Elmargasse 2-4",
    countryZIP: "A-1190 Vienna",
    website: "www.greco.services",
    infoOne: "HG Wien, FN 70663 t",
    infoTwo: "",
    infoThree: "Reg.No.24559249",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Datenschutzerklärung",
        protectionURL: "https://greco.services/ATGIH_PRIVACY_NOTICE_CLIENTS/",
      },
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL:
          "https://greco.services/wp-content/uploads/2024/11/ATGIH_PRIVACY_NOTICE_CLIENTS_EN.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal: undefined,
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 3,
    logoURL: undefined,
    country: "AT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+43 5 04 04 ",
    mobile: "+43 664 ",
    fax: "+43 5 04 04  11 ",
    companyName: "GrECo Risk Engineering GmbH",
    companyDisplayName: "GrECo Risk Engineering GmbH",
    logo: GrecoLogoNew,
    activityDescription: "Risikoberater und Versicherungsmakler",
    streetNumber: "Elmargasse 2-4",
    countryZIP: "A-1190 Wien",
    website: "www.greco.services",
    infoOne: "HG Wien, FN 371345 x",
    infoTwo: "Firmensitz: Wien",
    infoThree: "GISA-Zahl 25267365",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Datenschutzerklärung",
        protectionURL: "https://greco.services/ATGRE_PRIVACY_NOTICE_CLIENTS/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Diese Information ist ausschließlich für den Adressaten bestimmt und kann vertrauliche und geschützte Informationen enthalten. Die Verwendung durch Andere, Veröffentlichung, Kopie und Verteilung dieser Information an Dritte ist nicht gestattet. Sollten Sie nicht der beabsichtigte Empfänger sein, verständigen Sie bitte den Absender und löschen Sie dieses E-Mail dann sofort.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 4,
    logoURL: undefined,
    country: "AT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+43 5 04 04 ",
    mobile: "+43 664 ",
    fax: "+43 5 04 04  11 ",
    companyName: "GrECo Specialty GmbH",
    companyDisplayName: "GrECo Specialty GmbH",
    logo: GrecoLogoNew,
    activityDescription: "Risikoberater und Versicherungsmakler",
    streetNumber: "Elmargasse 2-4",
    countryZIP: "A-1190 Wien",
    website: "www.greco.services",
    infoOne: "HG Wien, FN 82712 k",
    infoTwo: "Firmensitz: Wien",
    infoThree: "GISA-Zahl 23816688",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Datenschutzerklärung",
        protectionURL: "https://greco.services/ATGRE_PRIVACY_NOTICE_CLIENTS/",
      },
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL:
          "https://greco.services/wp-content/uploads/2024/11/ATGSP_PRIVACY_NOTICE_CLIENTS_EN.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Diese Information ist ausschließlich für den Adressaten bestimmt und kann vertrauliche und geschützte Informationen enthalten. Die Verwendung durch Andere, Veröffentlichung, Kopie und Verteilung dieser Information an Dritte ist nicht gestattet. Sollten Sie nicht der beabsichtigte Empfänger sein, verständigen Sie bitte den Absender und löschen Sie dieses E-Mail dann sofort.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  // {
  //   id: 5,
  //   logoURL: undefined,
  //   country: "AT",
  //   firstLastName: undefined,
  //   jobTitle: undefined,
  //   email: "@greco.services",
  //   telephone: "+43 5 04 04 ",
  //   mobile: "+43 664 ",
  //   fax: "+43 5 04 04  11 ",
  //   companyName: "VMG Versicherungsmakler GmbH",
  //   companyDisplayName: "VMG Versicherungsmakler GmbH",
  //   logo: VGMLogoNew,
  //   activityDescription: "Risikoberater und Versicherungsmakler",
  //   streetNumber: "Elmargasse 2-4",
  //   countryZIP: "A-1190 Wien",
  //   website: "www.vmg.at",
  //   infoOne: "HG Wien, FN 105199f",
  //   infoTwo: "Firmensitz: Wien",
  //   infoThree: "GISA-Zahl 23793750",
  //   infoFour: undefined,
  //   infoFive: undefined,
  //   linkedIn: "https://www.linkedin.com/company/vmg-versicherungsmakler-gmbh",
  //   twitter: "https://twitter.com/greco_services",
  //   facebook: "https://www.facebook.com/greco.services",
  //   XING: "https://www.xing.com/pages/grecoaustria",
  //   instagram: "https://www.instagram.com/greco.services",
  //   protections: [
  //     {
  //       protectionText: "GrECo Datenschutzerklärung",
  //       protectionURL:
  //         "https://www.vmg.at/ATVMG_data_protection_declaration_clients.pdf",
  //     },
  //   ],
  //   additionalLink: undefined,
  //   legalLocal:
  //     "Diese Information ist ausschließlich für den Adressaten bestimmt und kann vertrauliche und geschützte Informationen enthalten. Die Verwendung durch Andere, Veröffentlichung, Kopie und Verteilung dieser Information an Dritte ist nicht gestattet. Sollten Sie nicht der beabsichtigte Empfänger sein, verständigen Sie bitte den Absender und löschen Sie dieses E-Mail dann sofort.",
  //   legalEnglisch:
  //     "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  // },
  {
    id: 6,
    logoURL: undefined,
    country: "BG",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo Bulgaria EOOD",
    companyDisplayName: "GrECo Bulgaria EOOD",
    logo: GrecoLogoNew,
    activityDescription: "Риск консултанти и Застрахователни брокери",
    streetNumber: "11-13 Yunak Str., fl. 7",
    countryZIP: "BG-1612 Sofia",
    website: "www.greco.services",
    infoOne: "ЕИК No 121707777",
    infoTwo: undefined,
    infoThree: "612-ЗБ/14.05.2019",
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-international-bulgaria",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL: "https://greco.services/BGG_PRIVACY_NOTICE_CLIENTS/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Тази информация е предназначена единствено за получателя на имейла и може да съдържа поверителна и защитена информация. Използването от други лица, публикуване, копиране и разпространение на тази информация на трети лица, не е разрешено. Ако този имейл не е предназначен за Вас, моля уведомете подателя и веднага след това го изтрийте.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 7,
    logoURL: undefined,
    country: "CZ",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+420 ",
    mobile: "+420 ",
    fax: undefined,
    companyName: "GrECo International s.r.o.",
    companyDisplayName: "GrECo International s.r.o.",
    logo: GrecoLogoNew,
    activityDescription: "Risk Consultants and Insurance Brokers",
    streetNumber: "Lomnického 1705/9",
    countryZIP: "CZ-140 00 Praha 4",
    website: "www.greco.services",
    infoOne: "IČ 45793107",
    infoTwo: "DIČ: CZ45793107",
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-czech-republic",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "Oznámení o ochraně osobních údajů",
        protectionURL: "https://greco.services/CZG_PRIVACY_NOTICE_CLIENTS/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Tato informace je určena výhradně pro použití adresáta a obsahuje informace, které mohou být důvěrné a privilegované. Používání jinými uživateli, zveřejňování, kopírování a distribuce této informace třetím stranám není povoleno. Pokud nejste určeným příjemcem, informujte o tom odesílatele a okamžitě tento e-mail odstraňte.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 8,
    logoURL: undefined,
    country: "EE",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo Specialty GmbH Eesti filial",
    companyDisplayName: "GrECo Specialty GmbH Eesti filial",
    logo: GrecoLogoNew,
    activityDescription: "Riski konsultant ja kindlustusmaakler",
    streetNumber: "Telliskivi 60i, A door, 3rd floor",
    countryZIP: "10412 Tallinn, Estonia",
    website: "www.greco.services",
    infoOne: "Registrikood.  12592796",
    infoTwo: undefined,
    infoThree: "GISA-Zahl 23816688",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL: "https://greco.services/EEG_PRIVACY_NOTICE_CLIENTS/",
      },
      // {
      //   protectionText: "GrECo Data Protection Declaration EN",
      //   protectionURL:
      //     "https://greco.services/wp-content/uploads/2024/11/EEG_PRIVACY_NOTICE_CLIENTS.pdf",
      // },
    ],
    additionalLink: undefined,
    legalLocal: undefined,
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 9,
    logoURL: undefined,
    country: "HR",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo Croatia d.o.o.",
    companyDisplayName: "GrECo Croatia d.o.o.",
    logo: GrecoLogoNew,
    activityDescription:
      "Konzultant za rizike i broker u osiguranju i reosiguranju",
    streetNumber: "Julija Knifera 6, 1st floor",
    countryZIP: "HR-10000 Zagreb",
    website: "www.greco.services",
    infoOne: "Reg. br. 080012200",
    infoTwo: undefined,
    infoThree: "DP 012 ",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL: "https://greco.services/HRG_PRIVACY_NOTICE_CLIENTS/",
      },
      {
        protectionText: "General Terms and Conditions",
        protectionURL:
          "https://greco.services/wp-content/uploads/2025/07/GrECo-Croatia-d.o.o.-Opci-uvjeti-i-informacije-2025.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Ova informacija je namijenjena isključivo za primatelja e-maila i sadržava informacije koje mogu biti povjerljive i povlaštene. Korištenje od strane drugih, objavljivanje, reprodukcija i distribucija trećim stranama nije dopuštena. Ukoliko niste primatelj kojemu je namijenjena ova poruka, molimo obavijestite pošiljatelja i odmah izbrišite e-mail poruku. ",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 10,
    logoURL: undefined,
    country: "HU",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName:
      "GrECo Hungary Biztosítási Alkusz Korlátolt Felelősségű Társaság",
    companyDisplayName:
      "GrECo Hungary Biztosítási Alkusz Korlátolt Felelősségű Társaság",
    logo: GrecoLogoNew,
    activityDescription: "Kockázatkezelési Tanácsadó és Biztosítási Alkusz",
    streetNumber: "Perc utca 8.",
    countryZIP: "HU-1036 Budapest",
    website: "www.greco.services",
    infoOne: "Adószám: 10342433-2-41",
    infoTwo: "MNB: 204121401072",
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-hungary",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL: "https://greco.services/HUG_PRIVACY_NOTICE_CLIENTS/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Ez az információ kizárólag a címzett/címzettek számára szól és bizalmas információkat tartalmazhat. Más személy általi felhasználása, megosztása, másolása és sokszorosítása harmadik fél felé nem megengedett. Ha Ön nem címzettje az üzenetnek, kérjük értesítse erről a feladót és törölje ezt az e-mailt.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 11,
    logoURL: undefined,
    country: "LT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+370",
    mobile: "+370",
    fax: "",
    companyName: "GrECo Lietuva, UADBB",
    companyDisplayName: "GrECo Lietuva, UADBB - LT",
    logo: GrecoLogoNew,
    activityDescription: "Rizikos Konsultantai ir Draudimo brokeriai",
    streetNumber: "Ukmergės g. 223-4, 8th floor",
    countryZIP: "LT-07156 Vilnius",
    website: "www.greco.services",
    infoOne: "Juridinio asmens kodas 123712730",
    infoTwo: undefined,
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-sagauta-lithuania",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: undefined,
    additionalLink: undefined,
    legalLocal: `Šios žinutės siuntėjas yra GrECo Lietuva, UADBB ir joje bei jos prieduose esanti informacija gali būti konfidenciali ar sudaryti siuntėjo komercinę paslaptį. Jeigu Jūs gavote šią žinutę per klaidą, prašome informuoti siuntėją ir nedelsiant ištrinti žinutę bei jos priedus iš savo elektroninių ryšių priemonių ir sistemos - šios žinutės ir jos prieduose esančios informacijos naudojimas, platinimas, atskleidimas ir kopijavimas yra draudžiamas. UADBB „GrECo Lietuva", juridinio asmens kodas 123712730, buveinės adresas Ukmergės g. 223-4, Vilnius (Bendrovė) siekiant įvertinti Jūsų draudimo poreikius ir pateikti Jums aktualų draudimo pasiūlymą, taip pat siekiant tarpininkauti Jums sudarant draudimo sutartį, draudimo sutarties administravimo tikslu, taip pat siekiant pateikti Jums aktualų pasiūlymą dėl Mūsų teikiamų paslaugų, siekiant užtikrinti savo teisėtus interesus bei vystyti savo teikiamas paslaugas tvarkys Jūsų asmens duomenis: 1) identifikacinius ir kontaktinius duomenis; 2) draudimo poliso ir draudimo sutartyje esančius asmens duomenis; 3) finansinius su draudimo sutarties vykdymu susijusius asmens duomenis; 4) Mūsų suformuotos ataskaitos draudikams duomenis; 5) draudžiamo objekto identifikacinius duomenis. Daugiau apie tai, kaip tvarkome Jūsų asmens duomenis rasite: <a href='https://greco.services/wp-content/uploads/2024/11/SAGAUTA_PRIVACY_NOTICE_CLIENTS.pdf'>https://greco.services/Duomenu_apsauga</a>`,
    legalEnglisch: undefined,
  },
  {
    id: 12,
    logoURL: undefined,
    country: "PL",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo Polska Sp. z o.o.",
    companyDisplayName: "GrECo Polska Sp. z o.o.",
    logo: GrecoLogoNew,
    activityDescription: "Broker Ubezpieczeniowy i Reasekuracyjny",
    streetNumber: "ul. Obozowa 57",
    countryZIP: "PL-01-161 Warszawa",
    website: "www.greco.services",
    infoOne: "KRS: 0000049997",
    infoTwo: "XIII Wydział Gospodarczy KRS",
    infoThree: "Regon: 192090882",
    infoFour: "NIP: 586-20-51-653",
    infoFive: "Kapitał zakładowy: 14 063 348,00 zł.",
    // linkedIn: "https://www.linkedin.com/company/grecopoland/",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "Polityka Prywatności GrECo",
        protectionURL: "https://greco.services/PLG_PRIVACY_NOTICE_CLIENTS/",
      },
    ],
    additionalLink: undefined,
    legalLocal: `<p>
        GrECo Polska Sp. z o.o. z siedzibą w Warszawie (01-161), ul. Obozowa 57, jest brokerem ubezpieczeniowym i reasekuracyjnym wpisanym do rejestru brokerów ubezpieczeniowych, prowadzonego przez Komisję Nadzoru Finansowego.
      </p>
      <p>
        Aktualne dane z rejestru brokerów ubezpieczeniowych udostępniane są przez Komisję Nadzoru Finansowego za pośrednictwem strony internetowej KNF. Wniosek w formie elektronicznej składany za pośrednictwem strony internetowej powinien zapewniać identyfikację podmiotu występującego z wnioskiem. Dane kontaktowe do Komisji Nadzoru Finansowego znajdują się na stronie internetowej KNF pod adresem:
        <a href="https://www.knf.gov.pl" target="_blank">www.knf.gov.pl</a> .
      </p>
      <p>
        W godzinach pracy urzędu obsługującego KNF wnioskodawcy mogą osobiście uzyskać dostęp do informacji na wydzielonym stanowisku komputerowym. Wpis do rejestru można sprawdzić także podając dane GrECo Polska Sp. z o.o.
        <a href="https://rpu.knf.gov.pl" target="_blank">na stronie internetowej KNF</a>.
      </p>
      <p>
        <a href="https://site.greco.services/downloads/pl/GJP-Wpis-do-rejestru-2015.pdf" target="_blank">Zezwolenie nr 892/00</a> na wykonywanie
        działalności brokerskiej w zakresie ubezpieczeń oraz
        <a href="https://site.greco.services/downloads/pl/2017.09.27_KNF_Zgoda_Reasekuracja_GJP.pdf" target="_blank">Zezwolenie nr 77/R/17</a> na
        wykonywanie działalności brokerskiej w zakresie reasekuracji przez GrECo Polska Sp. z o.o. udzielone przez Komisję Nadzoru Finansowego są
        dostępne na naszej stronie internetowej.
      </p>
      <p>
        GrECo Polska Sp. z o.o. nie posiada akcji żadnego zakładu ubezpieczeń, uprawniających co najmniej do 10% głosów na walnym zgromadzeniu.
        Żaden zakład ubezpieczeń nie posiada udziałów GrECo Polska Sp. z o.o., uprawniających co najmniej do 10% głosów na zgromadzeniu
        wspólników.
      </p>
      <p>
        GrECo Polska Sp. z o.o. otrzymuje w ramach wynagrodzenia kurtaż brokerski od zakładu ubezpieczeń lub honorarium od klienta, z którym
        zostaje zawarta umowa ubezpieczenia za pośrednictwem GrECo Polska Sp. z o.o. Poza kurtażem i honorarium GrECo Polska Sp. z o.o. nie
        otrzymuje dodatkowego wynagrodzenia.
      </p>
      <p>
        Reklamacje można składać wysyłając korespondencję w formie pisemnej na adres ul. Obozowa 57, 01-161 Warszawa, a także w formie elektronicznej na adres poczty elektronicznej
        <a href="mailto:reklamacje-broker@greco.services">reklamacje-broker@greco.services</a>.
      </p>
      <p>
        Ewentualny spór między klientem a GrECo Polska Sp. z o.o. może być zakończony w drodze pozasądowego postępowania w sprawie rozwiązywania
        sporów między klientem a brokerem jako podmiotem rynku finansowego, zgodnie z ustawą z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji
        przez podmioty rynku finansowego i o Rzeczniku Finansowym.
      </p>
      <p>
        Klienci GrECo Polska Sp. z o.o. mają możliwość złożenia skargi na działalność spółki do właściwych organów, w tym Komisji Nadzoru
        Finansowego, Urzędu Ochrony Konkurencji i Konsumentów.
      </p>
      `,
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 13,
    logoURL: undefined,
    country: "RO",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo Romania GmbH - Viena Sucursala Bucureşti",
    companyDisplayName: "GrECo Romania GmbH - Viena Sucursala Bucureşti",
    logo: GrecoLogoNew,
    activityDescription: "Consultant de risc si Broker de asigurare",
    streetNumber: "Bulevardul Corneliu Coposu nr. 6-8",
    countryZIP: "RO-030606 Bucuresti",
    website: "www.greco.services",
    infoOne: "Nr. înreg. la Registrul Comerțului: J2009009201401",
    infoTwo: undefined,
    infoThree: "GISA-Zahl 25093261",
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-romania",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL: "https://greco.services/ROG_PRIVACY_NOTICE_CLIENTS/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Aceste informaţii sunt adresate exclusiv pentru utilizarea destinatarului şi conţin date care pot fi confidenţiale. Utilizarea, copierea, distribuirea sau divulgarea acestor informaţii către terţe părţi nu este permisă. Daca nu sunteti destinatarul vizat, va rugam sa anuntati expeditorul şi apoi ştergeţi acest e-mail imediat.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 14,
    logoURL: undefined,
    country: "RS",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo International doo, Beograd",
    companyDisplayName: "GrECo International doo, Beograd",
    logo: GrecoLogoNew,
    activityDescription: "Društvo za posredovanje u osiguranju",
    streetNumber: "Stopićeva 8",
    countryZIP: "RS-11077 Novi Beograd",
    website: "www.greco.services",
    infoOne: "Dozvola za rad NBS br. 8496",
    infoTwo: "Matični broj: 20106310",
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice - Izjava o zaštiti podataka",
        protectionURL:
          "https://greco.services/wp-content/uploads/2024/11/RSG_PRIVACY_NOTICE_CLIENTS.pdf",
      },
    ],
    additionalLink: [
      {
        text: "Molimo Vas pročitajte informacije za Ugovarača osiguranja na sledećem linku:",
        linkText:
          "Informacije za Ugovarača osiguranja pre zaključenja Ugovora o osiguranju.",
        linkURL:
          "https://greco.services/wp-content/uploads/2023/05/Informacije_za_Ugovaraca_SR_FINAL.pdf",
      },
    ],
    legalLocal:
      "Ova e-mail poruka je isključivo namenjena za upotrebu primaoca i sadrži informacije koje mogu biti poverljive i privilegovane. Korišćenje od strane drugih, otkrivanje, kopiranje i distribucija ovih informacija trećim licima nije dozvoljena. Ako ova poruka nije namenjena vama, molimo da obavestite pošiljaoca i odmah zatim poruku obrišete.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 15,
    logoURL: undefined,
    country: "RS",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo Tech Hub d.o.o",
    companyDisplayName: "GrECo Tech Hub d.o.o",
    logo: GrecoLogoNew,
    activityDescription: "Društvo za posredovanje u osiguranju",
    streetNumber: "Milentija Popovića 5b,Sava Business Center, Kula B IV sprat",
    countryZIP: "RS-11077 Novi Beograd",
    website: "www.greco.services",
    infoOne: undefined,
    infoTwo: undefined,
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: undefined,
    additionalLink: undefined,
    legalLocal:
      "Ova e-mail poruka je isključivo namenjena za upotrebu primaoca i sadrži informacije koje mogu biti poverljive i privilegovane. Korišćenje od strane drugih, otkrivanje, kopiranje i distribucija ovih informacija trećim licima nije dozvoljena. Ako ova poruka nije namenjena vama, molimo da obavestite pošiljaoca i odmah zatim poruku obrišete.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 16,
    logoURL: undefined,
    country: "SI",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo International d.o.o.",
    companyDisplayName: "GrECo International d.o.o.",
    logo: GrecoLogoNew,
    activityDescription: "Upravljanje tveganj in zavarovalno posredništvo",
    streetNumber: "Vurnikova ulica 2",
    countryZIP: "SI-1000 Ljubljana",
    website: "www.greco.services",
    infoOne: "Mat. št. 5633176000",
    infoTwo: undefined,
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL: "https://greco.services/sig_privacy_notice_clients/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Te informacije so namenjene izključno naslovniku in vsebujejo informacije, ki so zaupne narave. Uporaba drugih, razkritje, kopiranje in distribucija teh informacji tretjim osebam ni dovoljena. Če niste nameravani prejemnik prosimo, da obvestite pošiljatelja in e-pošto nemudoma izbrišete. ",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 17,
    logoURL: undefined,
    country: "SK",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+421",
    mobile: "+421",
    fax: undefined,
    companyName: "GrECo Slovakia GmbH - organizačná zložka",
    companyDisplayName: "GrECo Slovakia GmbH - organizačná zložka",
    logo: GrecoLogoNew,
    activityDescription: "Risk Consultants and Insurance Brokers",
    streetNumber: "Polus Tower I, 15th floor, Vajnorská 100/A",
    countryZIP: "SK-831 04 Bratislava",
    website: "www.greco.services",
    infoOne: "IČO: 36 866 059",
    infoTwo: undefined,
    infoThree: "GISA-Zahl 25105117",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL: "https://greco.services/skg_privacy_notice_clients/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Táto informácia je výlučne určená pre adresáta a môže obsahovať dôverné a chránené informácie. Použitie inými osobami, zverejnenie, kopírovanie ako aj distribúcia tretím osobám nie je dovolená. Ak Vám tento email nebol určený, prosím oznámte to odosielateľovi a bezodkladne ho vymažte.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 18,
    logoURL: undefined,
    country: "TR",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo International Sigorta ve Reasürans Brokerliği A.Ş.",
    companyDisplayName:
      "GrECo International Sigorta ve Reasürans Brokerliği A.Ş.",
    logo: GrecoLogoNew,
    activityDescription: "Risk Danışmanı ve Sigorta Brokeri",
    streetNumber:
      "Çamlıca Bulgurlu Mah. Alemdağ Cad. No: 60\nMasaldan İş Merkezi E Blok / 3.Kısım",
    countryZIP: "TR-34692 Üsküdar / İstanbul",
    website: "www.greco.services",
    infoOne: "Sicil No: 865836",
    infoTwo: undefined,
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-turkey",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: undefined,
    additionalLink: undefined,
    legalLocal:
      "Bu e-posta ve içeriği GrECo International Sigorta ve Reasürans Brokerliği A.Ş. çalışanları tarafından iş amaçlı oluşturulmuştur ve kişisel verilerle gizli kalması gerekli ticari verileri içerebilir. Şayet bu e-posta size yanlışlıkla iletilmiş ya da kişisel verileri veya ticari sırları içeriyor ise 6698 sayılı Kişisel Verilerin Korunması Kanunu gereğince sisteminizden silinmesini tavsiye eder, aksi durumun sorumluluğa yol açabileceğini hatırlatırız.",
    legalEnglisch:
      "This e-mail and its contents have been formed by GrECo International Sigorta ve Reasürans Brokerliği A.Ş. employees intended for business purposes and may contain personal data and commercial data that is required to be kept confidential. If this e-mail contains personal data or commercial secrets or if it has been sent to you by mistake, we advise you to delete it from your system in accordance with the Law on the Protection of Personal Data No. 6698 and otherwise a responsibility may arise.",
  },
  {
    id: 19,
    logoURL: undefined,
    country: "UA",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+38 044 287 55 55",
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo Ukraine Risk Insurance Management LLC",
    companyDisplayName: "GrECo Ukraine Risk Insurance Management LLC",
    logo: GrecoLogoNew,
    activityDescription: "Risk Consultants and Insurance Agents",
    streetNumber: "20 Esplanadna St., office 310",
    countryZIP: "01001 Kyiv",
    website: "www.greco.services",
    infoOne: "USREOU 32192974",
    infoTwo: undefined,
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // linkedIn: "https://www.linkedin.com/company/greco-ukraine",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: undefined,
    additionalLink: undefined,
    legalLocal: undefined,
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 20,
    logoURL: undefined,
    country: "PL",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "Athena Sp. z o.o.",
    companyDisplayName: "Athena Sp. z o.o.",
    logo: AthenaLogoNew,
    activityDescription: "Członek Grupy GrECo",
    streetNumber: "ul. Winklera 18",
    countryZIP: "PL-60-246 Poznań",
    website: "www.greco.services",
    infoOne: "KRS: 0000166079",
    infoTwo: "VIII Wydział Gospodarczy KRS",
    infoThree: "Regon: 631047533",
    infoFour: "NIP: 782-20-29-074",
    infoFive: "Kapitał zakładowy: 60.000 zł.",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // linkedIn: "https://www.linkedin.com/company/grecopoland/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "Polityka Prywatności Athena",
        protectionURL:
          "https://www.athena.pgb.pl/images/polityka_prywatnosci.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Athena Sp. z o.o. z siedzibą w Poznaniu (60-246), ul. Winklera 18, jest brokerem ubezpieczeniowym wpisanym do rejestru brokerów ubezpieczeniowych, prowadzonego przez Komisję Nadzoru Finansowego. Aktualne dane z rejestru brokerów ubezpieczeniowych udostępniane są przez Komisję Nadzoru Finansowego za pośrednictwem strony internetowej KNF. Wniosek w formie elektronicznej składany za pośrednictwem strony internetowej powinien zapewniać identyfikację podmiotu występującego z wnioskiem. Dane kontaktowe do Komisji Nadzoru Finansowego znajdują się na stronie internetowej KNF pod adresem: www.knf.gov.pl . W godzinach pracy urzędu obsługującego KNF wnioskodawcy mogą osobiście uzyskać dostęp do informacji na wydzielonym stanowisku komputerowym. Wpis do rejestru można sprawdzić także podając dane Athena Sp. z o.o. na stronie internetowej KNF. Licencja PUNU 452 na wykonywanie działalności brokerskiej w zakresie ubezpieczeń przez Athena Sp. z o.o. jest dostępna na naszej stronie internetowej. Athena Sp. z o.o. otrzymuje w ramach wynagrodzenia kurtaż brokerski od zakładu ubezpieczeń lub honorarium od klienta, z którym zostaje zawarta umowa ubezpieczenia za pośrednictwem Athena Sp. z o.o. Poza kurtażem i honorarium Athena Sp. z o.o. nie otrzymuje dodatkowego wynagrodzenia. Reklamacje można składać wysyłając korespondencję w formie pisemnej na adres ul. Winklera 18, 60-246 Poznan, a także w formie elektronicznej na adres poczty elektronicznej kontakt@athena.pgb.pl. Ewentualny spór między klientem a Athena Sp. z o.o. może być zakończony w drodze pozasądowego postępowania w sprawie rozwiązywania sporów między klientem a brokerem jako podmiotem rynku finansowego, zgodnie z ustawą z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego i o Rzeczniku Finansowym. Klienci Athena Sp. z o.o. mają możliwość złożenia skargi na działalność spółki do właściwych organów, w tym Komisji Nadzoru Finansowego, Urzędu Ochrony Konkurencji i Konsumentów. Szanowni Państwo, powyższa wiadomość jest przeznaczona wyłącznie do użytku przez jej docelowego adresata i może zawierać informacje poufne. Korzystanie, ujawnianie, kopiowanie i rozpowszechnianie tej wiadomości osobom trzecim jest zabronione. Jeżeli nie jesteście Państwo adresatem tej wiadomości, prosimy o poinformowanie o tym  nadawcy, a następnie usunięcie tej wiadomości.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 21,
    logoURL: undefined,
    country: "AL",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+355",
    mobile: "+355",
    fax: "",
    companyName: "GrECo Albania",
    companyDisplayName: "GrECo Albania",
    logo: GrecoLogoNew,
    activityDescription: "Konsulente Risku dhe Broker Sigurimesh",
    streetNumber: "Rr. Murtezim Kellici, Kulla AL -FAM, Kati 5 , No.22",
    countryZIP: "1001, Tirana, Albania",
    website: "www.greco.services",
    infoOne: "",
    infoTwo: "",
    infoThree: "",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "",
    instagram: "https://www.instagram.com/greco.services",
    protections: [],
    additionalLink: undefined,
    legalLocal: "",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 22,
    logoURL: undefined,
    country: "GE",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+995",
    mobile: "+995",
    fax: "",
    companyName: "GrECo Georgia Insurance and Reinsurance Brokers Ltd",
    companyDisplayName: "GrECo Georgia Insurance and Reinsurance Brokers Ltd",
    logo: GrecoLogoNew,
    activityDescription: "რისკ კონსულტანტი, დაზღვევის და გადაზღვევის ბროკერი",
    streetNumber: "5A, S. Mgaloblishvili Street",
    countryZIP: "Tbilisi 0160, Georgia",
    website: "www.greco.services",
    infoOne: "Company ID 205232942",
    infoTwo: "",
    infoThree: "",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "",
    instagram: "https://www.instagram.com/greco.services",
    protections: [],
    additionalLink: undefined,
    legalLocal: "",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 23,
    logoURL: undefined,
    country: "LT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+370",
    mobile: "+370",
    fax: "",
    companyName: "GrECo International LT, UADBB",
    companyDisplayName: "GrECo International LT, UADBB - EN",
    logo: GrecoLogoNew,
    activityDescription: "Rizikos Konsultantai ir Draudimo brokeriai",
    streetNumber: "Laisvės ave. 3",
    countryZIP: "LT-04215 Vilnius",
    website: "www.greco.services",
    infoOne: "",
    infoTwo: "",
    infoThree: "",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [],
    additionalLink: undefined,
    legalLocal: "",
    legalEnglisch:
      "<span style='color: #1e53a3;'>In order to provide you with insurance distribution services GrECo International LT, UADBB is processing your personal data. More information how we process your personal data can found in our <a href='https://greco.services/wp-content/uploads/2024/11/LTG_PRIVACY_NOTICE_CLIENTS_EN.pdf' target='_blank'>privacy policy</a>. We also invite you to get acquainted with the <a href='https://greco.services/wp-content/uploads/2023/12/Informacija-draudejui.pdf' target='_blank'>information for the policyholder</a>.</span><br/><b>This e-mail and any files transmitted with it are confidential and/or privileged and protected by the laws of copyright. They are for the intended recipient only. If you are not the intended recipient, you must not use, review, distribute, disclose, alter, print, copy, transmit or rely on this e-mail and any file transmitted with it. If you have received this e-mail and any file transmitted with it in error please notify the sender immediately.</b>",
  },
  {
    id: 24,
    logoURL: undefined,
    country: "LT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+370",
    mobile: "+370",
    fax: "",
    companyName: "GrECo International LT, UADBB",
    companyDisplayName: "GrECo International LT, UADBB - LT",
    logo: GrecoLogoNew,
    activityDescription: "Rizikos Konsultantai ir Draudimo brokeriai",
    streetNumber: "Laisvės ave. 3",
    countryZIP: "LT-04215 Vilnius",
    website: "www.greco.services, www.mai-cee.com",
    infoOne: "",
    infoTwo: "",
    infoThree: "",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [],
    additionalLink: undefined,
    legalLocal: "",
    legalEnglisch:
      "<span style='color: #1e53a3'>Siekdami teikti Jums draudimo produktų platinimo paslaugą GrECo International LT, UADBB tvarko Jūsų asmens duomenis. Susipažinti kaip tvarkome Jūsų asmens duomenis galite mūsų <a href='https://greco.services/wp-content/uploads/2024/11/LTG_PRIVACY_NOTICE_CLIENTS.pdf' target='_blank'>privatumo politikoje</a>. Taip pat kviečiame susipažinti su <a href='https://greco.services/wp-content/uploads/2023/12/Informacija-draudejui.pdf' target='_blank'>informacija draudėjui</a>.</span><br /><b>Šis el. laiškas ir visi kartu su juo perduodami failai yra konfidencialūs ir (arba) privilegijuojami ir saugomi autorių teisių įstatymų ir skirti tik numatytam gavėjui. Jei nesate numatytas gavėjas, jūs negalite naudoti, peržiūrėti, platinti, atskleisti, keisti, spausdinti, kopijuoti, perduoti ar pasikliauti šio el. laiško ir jokiu kartu su juo perduodamu failu. Jei šį el. laišką ir bet kurį su juo perduotą failą gavote per klaidą, nedelsdami praneškite siuntėjui.</b>",
  },
  {
    id: 25,
    logoURL: undefined,
    country: "LT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+370",
    mobile: "+370",
    fax: "",
    companyName: "GrECo Lietuva, UADBB",
    companyDisplayName: "GrECo Lietuva, UADBB - EN",
    logo: GrecoLogoNew,
    activityDescription: "Risk Consultants and Insurance Brokers",
    streetNumber: "Ukmergės g. 223-4, 8th floor",
    countryZIP: "LT-07156 Vilnius",
    website: "www.greco.services",
    infoOne: "Legal entity code 123712730",
    infoTwo: undefined,
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    // linkedIn: "https://www.linkedin.com/company/greco-sagauta-lithuania",
    linkedIn: "https://www.linkedin.com/company/grecogroup",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: undefined,
    additionalLink: undefined,
    legalLocal:
      "The sender of this message is GrECo Lietuva, UADBB and the information contained in it and its annexes may be confidential or constitute a commercial secrets of the sender. If you have received this message in error, please inform the sender and immediately delete the message and its attachments from your electronic means of communication and system - use, distribution, disclosure or copying of this message and its attachments is prohibited. UADBB GrECo Lietuva, legal entity code 123712730, registered office address Ukmergės str. 223-4, Vilnius (Company) in order to assess your insurance needs and provide you with a relevant insurance offers, as well as to mediate in concluding the insurance contracts, for the purpose of insurance contracts administration, as well as providing you with a relevant offer on our services, to ensure legal interests and develop the services we provide, will process your personal data: 1) identification and contact data; 2) personal data contained in the insurance policy and the insurance contract; 3) financial personal data related to the performance of the insurance contract; 4) data from our report to insurers; 5) identification data of the insured object. More information how we process your personal data You can find out at <a href='https://greco.services/wp-content/uploads/2024/11/SAGAUTA_PRIVACY_NOTICE_CLIENTS_EN.pdf'>https://greco.services/Data_protection</a>",
    legalEnglisch:
      "The sender of this message is GrECo Lietuva, UADBB and the information contained in it and its annexes may be confidential or constitute a commercial secrets of the sender. If you have received this message in error, please inform the sender and immediately delete the message and its attachments from your electronic means of communication and system - use, distribution, disclosure or copying of this message and its attachments is prohibited. UADBB GrECo Lietuva, legal entity code 123712730, registered office address Ukmergės str. 223-4, Vilnius (Company) in order to assess your insurance needs and provide you with a relevant insurance offers, as well as to mediate in concluding the insurance contracts, for the purpose of insurance contracts administration, as well as providing you with a relevant offer on our services, to ensure legal interests and develop the services we provide, will process your personal data: 1) identification and contact data; 2) personal data contained in the insurance policy and the insurance contract; 3) financial personal data related to the performance of the insurance contract; 4) data from our report to insurers; 5) identification data of the insured object. More information how we process your personal data You can find out at <a href='https://greco.services/wp-content/uploads/2024/11/SAGAUTA_PRIVACY_NOTICE_CLIENTS_EN.pdf'>https://greco.services/Data_protection</a>",
  },
  {
    id: 26,
    logoURL: undefined,
    country: "BH",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: undefined,
    mobile: undefined,
    fax: undefined,
    companyName: "GrECo BH d.o.o.",
    companyDisplayName: "GrECo BH d.o.o.",
    logo: GrecoLogoNew,
    activityDescription: "Broker u osiguranju",
    streetNumber: "Fra Anđela Zvizdovića 1",
    countryZIP: "BA-71000 Sarajevo",
    website: "www.greco.services",
    infoOne: undefined,
    infoTwo: undefined,
    infoThree: undefined,
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: undefined,
    instagram: "https://www.instagram.com/greco.services",
    protections: undefined,
    additionalLink: undefined,
    legalLocal:
      "Ova e-mail poruka je isključivo namenjena za upotrebu primaoca i sadrži informacije koje mogu biti poverljive i privilegovane. Korišćenje od strane drugih, otkrivanje, kopiranje i distribucija ovih informacija trećim licima nije dozvoljena. Ako ova poruka nije namenjena vama, molimo da obavestite pošiljaoca i odmah zatim poruku obrišete.",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 27,
    logoURL: null,
    country: "LT",
    firstLastName: null,
    jobTitle: null,
    email: null,
    telephone: null,
    mobile: null,
    fax: null,
    companyName: 'SIA "GrECo Latvia"',
    companyDisplayName: 'SIA "GrECo Latvia"',
    logo: GrecoLogoNew,
    activityDescription:
      "Starptautisks Risku vadības konsultants un Apdrošināšanas brokeris",
    streetNumber: "Vienības gatve 109",
    countryZIP: "LV-1058 Riga",
    website: "www.greco.services",
    infoOne: "Risk Consultants and Insurance Brokers",
    infoTwo: null,
    infoThree: null,
    infoFour: null,
    infoFive: null,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    facebook: "https://www.facebook.com/greco.services",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "Privātuma politika",
        protectionURL: "https://greco.services/LVG_PRIVACY_NOTICE_CLIENTS",
      },
      {
        protectionText: "Sadarbības noteikumi",
        protectionURL: "https://www.iizi.lv/sadarbibas-noteikumi/",
      },
    ],
    additionalLink: undefined,
    legalLocal:
      "Šis e-pasts ar tā pielikumiem (ja tādi ir) ir paredzēts tikai augstāk norādītajam saņēmējam(iem). Tas var saturēt informāciju, kura ir ierobežota, konfidenciāla un/vai neizziņojama atbilstoši piemērojamajam likumam un tāpēc jebkāda šīs informācijas izplatīšana ir atļauta tikai ar sūtītāja piekrišanu, ja e-pastā nav norādīts savādāk. Ja jūs esat saņēmis šo ziņu kļūdas dēļ vai arī neesat norādītais saņēmējs(i), ar šo jūs informējam, ka jebkāda šīs informācijas izpaušana, kopēšana un izplatīšana ir stingri aizliegta un var būt nelikumīga. Lūdzu nekavējoties informējiet sūtītāju un izdzēsiet šo e-pasta ziņu un jebkādus pielikumus no savas sistēmas. Paldies!",
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 28,
    logoURL: undefined,
    country: "AT",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "",
    mobile: "",
    fax: "",
    companyName: "GrECo Specialty GmbH, Wien, Zweigniederlassung Hünenberg",
    companyDisplayName:
      "GrECo Specialty GmbH, Wien, Zweigniederlassung Hünenberg",
    logo: GrecoLogoNew,
    activityDescription: "Risk Consultants and Insurance Brokers",
    streetNumber: "Rothusstrasse 21",
    countryZIP: "6331 Hünenberg, Switzerland",
    website: "www.greco.services",
    infoOne: "",
    infoTwo: "",
    infoThree: "",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL:
          "https://greco.services/wp-content/uploads/2024/11/ATGIH_PRIVACY_NOTICE_CLIENTS_EN.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal: undefined,
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
  {
    id: 29,
    logoURL: undefined,
    country: "GR",
    firstLastName: undefined,
    jobTitle: undefined,
    email: "@greco.services",
    telephone: "+30 ",
    mobile: "+30 ",
    fax: "",
    companyName: "GrECo Hellas Risk Managers & Insurance Brokers SA",
    companyDisplayName: "GrECo Hellas Risk Managers & Insurance Brokers SA",
    logo: GrecoLogoNew,
    activityDescription: "Risk Managers & Insurance Brokers",
    streetNumber: "9 Brahamiou Street, Marousi",
    countryZIP: "GR-15124 Athens",
    website: "www.greco.services",
    infoOne: "Société Anonyme Company Registry Nr. 50724/01ΑΤ/Β/01/300(08)",
    infoTwo: "Insurance Broker License Nr. 227848/38",
    infoThree: "",
    infoFour: undefined,
    infoFive: undefined,
    linkedIn: "https://www.linkedin.com/company/grecogroup/",
    // twitter: "https://twitter.com/greco_services",
    facebook: "https://www.facebook.com/greco.services",
    // XING: "https://www.xing.com/pages/grecoaustria",
    instagram: "https://www.instagram.com/greco.services",
    protections: [
      {
        protectionText: "GrECo Privacy Notice",
        protectionURL:
          "https://greco.services/wp-content/uploads/2024/11/ATGIH_PRIVACY_NOTICE_CLIENTS_EN.pdf",
      },
    ],
    additionalLink: undefined,
    legalLocal: undefined,
    legalEnglisch:
      "This information is intended solely for the use of the addressee and contains information that may be confidential and privileged. Use by others, disclosure, copying and distribution of this information to third parties is not permitted. If you are not the intended recipient, please notify the sender and then delete this e-mail immediately.",
  },
];
